export const usersSortByOptions = ['Name', 'Email', 'Role'];
export const preConfiguredFilters = {
    ALL_USERS: 'All users',
};
